export default __webpack_public_path__ + "static/Knockout-74FullSumo-e28fb152c0c7d4935fb1b786604244e4.otf";